<template>
  <div>
    <!--编辑 -->
    <el-dialog title="编辑" :visible.sync="dialog" @close="unShowClick()">
      <el-form ref="addBody" :rules="rules" :model="addBody">
        <el-form-item prop="menu_name" label="菜单名称" :label-width="formLabelWidth">
          <el-input v-model="addBody.menu_name"/>
        </el-form-item>
        <el-form-item label="菜单url" prop="menu_url" :label-width="formLabelWidth">
          <el-input v-model="addBody.menu_url"/>
        </el-form-item>
        <el-form-item label="菜单等级" prop="level" :label-width="formLabelWidth">
          <el-select v-model="addBody.level" placeholder="请选择菜单等级" @change="changetype">
            <el-option label="1" :value="1"></el-option>
            <el-option label="2" :value="2"></el-option>
            <el-option label="3" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单类型" prop="type" :label-width="formLabelWidth">
          <el-select v-model="addBody.type" placeholder="请选择菜单等级">
            <el-option label="菜单" value="1"></el-option>
            <el-option label="按钮" value="2"></el-option>
            <el-option  label="API" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addBody.level != 1" label="上级菜单" :label-width="formLabelWidth">
          <el-select v-model="addBody.pid">
            <el-option v-for="(item,index) in identTable" :key="index" :label="item.menu_name"
                       :value="item.menu_id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="unShowClick()">取 消</el-button>
        <el-button type="primary" @click="editUser('addBody')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMenuList,
  readMenu,
  LimitsList,
  getMenuListDetail,
  addMenu,
  SetMenu,
  getPermissionselect
} from '@/api/auth'
// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

export default {
  props: {
    uuid: {
      type: Object,
      default: {},
    },
    value: {
      type: Boolean,
      default: false,
    },
    dialogProp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      readid: '',
      dialog: false,
      identTable: [],
      formLabelWidth: '120px',
      addBody: {
        menu_name: '',
        menu_url: '',
        level: '',
      },
      isAddAdmin: true,
      rules: {
        menu_name: [{
          required: true,
          message: '请输入菜单名称',
          trigger: 'blur'
        },],
        menu_url: [{
          required: true,
          message: '请输入菜单menu_url',
          trigger: 'blur'
        },],
        level: [{
          required: true,
          message: '请输入菜单等级',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请输入菜单等级',
          trigger: 'change'
        }]
      },
    }
  },
  methods: {
    changetype() {
      this.network().identityOf()
    },
    editUser(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          if (this.isAddAdmin) {
            this.network().addmenu()
          } else {
            this.network().editMenu()
          }
          this.dialog = false
          this.$emit('input', false)
        } else {
          return false;
        }
        return false
      });
    },
    unShowClick() {
      this.$emit('input', false)
    },
    network() {
      return {
        // 菜单详细信息
        getAuthListDetail: async () => {
          const {
            status,
            data
          } = await readMenu({
            menu_id: this.readid
          })
          if (status !== 200) return
          console.log(data.result, '详情数据')
          this.addBody.pid = data.result.pid;
          this.addBody.menu_url = data.result.menu_url;
          this.addBody.menu_name = data.result.menu_name;
          this.addBody.level = data.result.level;
          this.addbody.type = data.result.type
          console.log(this.addBody);
        },
        // 上级菜单
        identityOf: async () => {
          const {
            data,
            status
          } = await getMenuList({
            level: this.addBody.level - 1
          })
          if (status !== 200) return
          console.log(data, 'dialog身份数据')
          var dataList = data.result.data;
          if (this.addBody.level == 1) {
            this.addBody.pid = "";
            this.identTable = []
          } else {
            this.identTable = dataList;
          }

        },
        // 添加菜单
        addmenu: async () => {
          console.log(this.addBody.pid, "父菜单");
          const {
            status
          } = await addMenu({
            menu_name: this.addBody.menu_name,
            menu_url: this.addBody.menu_url,
            level: this.addBody.level,
            type: this.addBody.type,
            pid: this.addBody.pid
          })
          if (status !== 200) return
          this.$emit("confirmClick")
        },
        // 编辑菜单
        editMenu: async () => {
          const {
            status
          } = await SetMenu({
            menu_id: this.readid,
            menu_name: this.addBody.menu_name,
            menu_url: this.addBody.menu_url,
            level: this.addBody.level,
            type: this.addBody.type,
            pid: this.addBody.pid,
          })
          if (status !== 200) return
          this.$emit("confirmClick")
        },
      }
    },
  },

  watch: {
    uuid(val) {
      this.isAddAdmin = true;
      this.addBody = {};
      if (Object.keys(val).length != 0) {
        console.log(val);
        this.isAddAdmin = false;
        this.readid = val.menu_id;
        this.addBody = val
        this.network().getAuthListDetail()
        this.network().identityOf()
      }

    },
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dialog = newVal
        this.network().identityOf()
        this.network().getAuthListDetail()
      }
    },
    dialogProp(old) {
      this.dialog = old;
    },

  },
};
</script>

<style scoped>
</style>
